import React from "react";

function AdventureAwaits() {
  return (
    <div className="page-container">
      <h2>⛰️ Adventure Awaits!</h2>
      <p>
        For thrill-seekers, we’ve handpicked adventurous destinations that offer
        unforgettable experiences.
      </p>
      <p>
        ✅ New Zealand – bungee jumping & skydiving paradise  
        ✅ Nepal – trek the Himalayas safely with guided tours  
        ✅ Costa Rica – rainforests, volcano hikes & ziplining fun
      </p>
      <p>
        Adventure is about pushing limits while staying safe – these
        destinations ensure both!
      </p>
      <img
        src="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee"
        alt="Adventure travel"
        style={{ width: "100%", borderRadius: "12px", marginTop: "20px" }}
      />
    </div>
  );
}

export default AdventureAwaits;
